import script from "./RegionTabs.vue?vue&type=script&setup=true&lang=js"
export * from "./RegionTabs.vue?vue&type=script&setup=true&lang=js"

import "./RegionTabs.vue?vue&type=style&index=0&id=c82f93d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c82f93d6"]])

export default __exports__